/**
 * The invoice header a vendor gets before saving their own layout. One list
 * for the API (what prints) and the web editor (what it seeds), so the two
 * can't disagree.
 *
 * The first rows are the ones the invoice printed before its header was
 * configurable, with their old labels. Invoice # is on so each page of a
 * job's combined PDF can be matched to its row on the summary. Species and
 * Producer are on because an invoice that says "half" without saying half of
 * WHAT is the complaint that started this.
 *
 * Two columns: the order on the left, the processor on the right.
 */
export const INVOICE_HEADER_DEFAULT_FIELDS: ReadonlyArray<{
  fieldKey: string;
  label: string;
  column: number;
}> = [
  { fieldKey: 'orderNumber', label: 'Processing', column: 1 },
  { fieldKey: 'invoiceNumber', label: 'Invoice #', column: 1 },
  { fieldKey: 'animalSpecies', label: 'Species', column: 1 },
  { fieldKey: 'producerName', label: 'Producer', column: 1 },
  { fieldKey: 'dropoffDate', label: 'Scheduled Dropoff Date', column: 2 },
  { fieldKey: 'processorName', label: 'Processor', column: 2 },
  { fieldKey: 'processorAddress', label: 'Processor address', column: 2 },
];

/** Printed when a vendor hasn't set an invoice title. */
export const INVOICE_HEADER_DEFAULT_TITLE = 'Billing Statement';

/** Longest title the settings form accepts. */
export const INVOICE_HEADER_TITLE_MAX_LENGTH = 60;
